import React, {Component} from 'react';
import Slider from "react-slick";
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import {Helmet} from "react-helmet";

class FotoGalerij extends Component {

    constructor(props) {
        super(props);
        this.selectSlide = this.selectSlide.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    selectSlide(index){
        this.slider1.slickGoTo(index);
    }
    handleKeyDown = (event) => {
        switch( event.keyCode ) {
            case 37: //left arrow key
                this.previous();
                break;
            case 39: //right arrow key
                this.next();
                break;
            default:
                break;
        }
    }

    next() {
        this.slider1.slickNext();
    }

    previous() {
        this.slider1.slickPrev();
    }

    componentDidMount() {
        window.addEventListener("keydown", this.handleKeyDown);
    };

    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleKeyDown);
    };
    render() {
        const settings_1 = {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            useTransform: false,
            lazyLoad: 'progressive',
            arrows: true,
        };
        const settings_2 = {
            infinite: false,
            centerMode: false,
            cssEase: 'ease-in-out',
            dots: false,
            lazyLoad: 'progressive',
            arrows: true,
            useTransform: false,
            responsive: [
                {
                    breakpoint: 791,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 491,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        };
        let images = [];
        if(this.props.images) {
            images = this.props.images;
        }

        const siteID = this.props.siteID;
        const imagesKeys = Object.keys(images);

        return(
                <div>
                    <Helmet>
                        <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"/>
                        <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"/>
                    </Helmet>
                    <Slider
                        {...settings_1}
                        infinite={false}
                        ref={slider => (this.slider1 = slider)}
                        className="main_slick-slider"
                    >
                        {
                            Object.keys(images).map((key,index) =>
                                <div key={index}  >
                                    <Slide {...images[key] } IMG={images[key]} size="large" height={"500px"} siteID={siteID} />
                                </div>
                            )
                        }

                    </Slider>
                    <div style={{ marginRight: '20px', marginLeft: '20px', marginTop: '5px'}}>
                        <Slider style={{ height: '100px'}}
                                {...settings_2}
                                slidesToShow={imagesKeys.length > 7 ? 7 : imagesKeys.length }
                                slidesToScroll={imagesKeys.length > 7 ? 7 : imagesKeys.length }
                                focusOnSelect={true}
                                ref={slider => (this.slider = slider)}
                                centerPadding= {'1px'}
                                infinite={false}
                                centerMode={false}
                        >
                            {
                                Object.keys(images).map((key,index)=>
                                    <div key={index} style={{ cursor: 'grab'}} >
                                        <Slide {...images[key]} IMG={ images[key] } size="small" height={"70px"} index={index} selectSlide={this.selectSlide} siteID={siteID} />
                                    </div>
                                )
                            }
                        </Slider>
                    </div>
                </div>
        )
    }
}

export default HeaderFooterHOC(FotoGalerij, 'gallery-wrapper');

const Slide = (props) => {
    const {padding, MediumID, selectSlide, size, height, IMG, index, siteID } = props;
    let url = IMG.url;
    if (typeof IMG.MediaGuid !== 'undefined') {

        if (size === 'large') {
            url = '/storage/sites/' + siteID + '/afbeeldingen/' + IMG.MediaGuid + '.jpg';
        } else {
            url = 'https://media.nvm.nl/600x/' + IMG.MediaGuid;
        }
    }

    const styling = {
        backgroundImage: 'url('+ url +')',
    };

    if (size === 'small') {
        return (
            <div key={MediumID} className="gallery-slide-small-image-wrapper" >
                <div className="gallery-slide-small-image" style={styling} onClick={() => selectSlide(index)}></div>
            </div>
        );
    }

    return (
        <div key={MediumID} className="gallery-slide-large-image-wrapper">
            <div className="gallery-slide-large-image" style={styling}></div>
        </div>
    );

};
